import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useFAQSchema } from "@/lib/seo";

const FAQS = [
  {
    q: "What is IPVALUE MARKETPLACE?",
    a: "IPVALUE MARKETPLACE is a closeout, overstock and liquidation store in Grand Rapids, Michigan (88 54th St SW, Suite 103, Grand Rapids, MI 49548). We sell brand-new furniture, mattresses, appliances, recliners, e-bikes, scooters and wholesale liquidation pallets at closeout prices — shop in-store or online with free local delivery on orders $299+ within 10 miles. Call or text +1-616-410-0158.",
  },
  {
    q: "Do you sell liquidation pallets near Grand Rapids?",
    a: "Yes — we sell manifested and unmanifested closeout & overstock pallets from our Grand Rapids store, with real photos and itemized manifests showing total Estimated Retail Value. You can also build your own custom pallet from live in-stock inventory: 3 items $500, 5 items $900, 7 items $1,500, 11 items $2,200, plus a flat $299 customization fee.",
  },
  {
    q: "Where does your merchandise come from?",
    a: "Truckload overstock straight from major retailers, closeouts and shelf pulls, store-closing inventories, and direct wholesale deals. Every item is tagged honestly as NEW, OPEN BOX or AS-IS — and we never invent a fake retail price to inflate a deal.",
  },
  {
    q: "What is a ★ GOLD DEAL?",
    a: "Gold Deals are our deepest discounts — the gold tag shows what the item sells for elsewhere right next to our price. They're pulled from our top sellers and best buys, stock is limited, and they usually can't be restocked. When they're gone, they're gone.",
  },
  {
    q: "Do you deliver in West Michigan?",
    a: "Yes. Delivery is FREE on orders $299+ within 10 miles of our Grand Rapids store, $39 under $299, $49 for 10–25 miles, and $49 + $2/mile beyond 25 miles. Deliveries run Tuesday, Thursday and Saturday. In-store pickup is always free during store hours (Mon–Sat 10–7, Sun 12–5).",
  },
  {
    q: "Can resellers buy wholesale pallets from you?",
    a: "Absolutely — resellers across Grand Rapids, Kentwood, Grandville, Byron Center and West Michigan buy our wholesale pallets to flip online and at markets. Bring a Michigan resale certificate (Form 3372) for tax-exempt pallet purchases, and ask about our Reseller Program.",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState(null);
  useFAQSchema(FAQS.map((f) => ({ q: f.q, a: f.a })));
  return (
    <section className="max-w-[1200px] mx-auto px-6 md:px-8 py-16" data-testid="home-faq-section">
      <div className="ipv-eyebrow text-[#C9971E]">Good to know</div>
      <h2 className="font-display font-black text-3xl tracking-tighter mt-2">
        Frequently asked questions
      </h2>
      <div className="mt-8 divide-y divide-gray-200 border-y border-gray-200">
        {FAQS.map((f, i) => (
          <div key={i}>
            <button
              onClick={() => setOpen(open === i ? null : i)}
              className="w-full flex items-center justify-between gap-4 py-5 text-left font-bold hover:text-[#0A1C40] transition-colors"
              data-testid={`faq-toggle-${i}`}
              aria-expanded={open === i}
            >
              <span>{f.q}</span>
              <ChevronDown className={`w-5 h-5 shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && (
              <p className="pb-5 text-sm text-gray-700 leading-relaxed max-w-3xl" data-testid={`faq-answer-${i}`}>
                {f.a}
              </p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
